<template>
  <div class="newscontent">
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label="标题" prop="title" style="margin-bottom: 40px">
        <el-input v-model="ruleForm.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content" style="margin-bottom: 40px">
        <el-input
          style="width: 700px"
          v-model="ruleForm.content"
          type="textarea"
          :rows="14"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="时间" prop="date" style="margin-bottom: 40px">
        <el-date-picker
          v-model="ruleForm.date"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="封面" prop="imageUrl" style="margin-bottom: 40px">
        <el-upload
          class="avatar-uploader"
          action="https://jsonplaceholder.typicode.com/posts/"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="ruleForm.imageUrl"
            :src="ruleForm.imageUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 100px;
        "
      >
        <el-button
          style="width: 300px; height: 50px; margin-top: 30px"
          type="primary"
          @click="submitForm('ruleForm')"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    var validatetitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("标题不能为空"));
      }
    };
    var validatecontent = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("内容不能为空"));
      }
    };
    var validatedate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("时间不能为空"));
      }
    };
    var validateimgurl = (rule, value, callback) => {
      if (!value) {
        // this.$message.error("封面不能为空");
        return callback(new Error("封面不能为空"));
      }
    };
    return {
      labelPosition: "right",
      ruleForm: {
        title: "",
        content: "",
        date: this.DateUtils.GetNowDate(),
        imageUrl: "",
      },

      rules: {
        title: [{ validator: validatetitle, trigger: "blur" }],
        content: [{ validator: validatecontent, trigger: "blur" }],
        // date: [{ validator: validatedate, trigger: "blur" }],
        imageUrl: [{ validator: validateimgurl, trigger: "blur" }],
      },
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.ruleForm.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      console.log("图片数据");
      console.log(file);
      return isJPG && isLt2M;
    },
    //提交
    submitForm(formName) {
      console.log(this.DateUtils.GetNowDate());
      console.log("点击了提交按钮");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("success");
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.newscontent {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 278px;
    height: 278px;
    line-height: 278px;
    text-align: center;
  }
  .avatar {
    width: 278px;
    height: 278px;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Addnews.vue